<template>
  <div class="upload-progress">
    <div class="upload-progress_bar">
      <progress
        class="progress is-primary"
        :value="uploadedNum"
        :max="maxNumOfUpload"
      />
      <i
        v-if="uploadingStatus === 'uploaded'"
        class="icon-check circle-icon icon_done"
        aria-hidden="true"
      />
    </div>
    <div
      v-if="uploadingStatus === 'uploading'"
      class="upload-progress_msg_uploading"
    >
      <p class="status">
        Uploading...
      </p>
      <p class="description">
        Pleas do not close this page until uploading is done.
      </p>
    </div>
    <div
      v-else
      class="upload-progress_msg_uploaded"
    >
      <p class="status">
        Done!
      </p>
      <p class="description">
        The data will be cleaned up and compiled to a single file.
      </p>
      <p class="description">
        Please find it in the History table below later.
      </p>
      <button
        class="button is-small okay-button"
        @click="$emit('close')"
      >
        Okay
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    uploadingStatus: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      uploadingFilesProgress: 'datalink/uploadingFilesProgress'
    }),
    maxNumOfUpload () {
      return this.uploadingFilesProgress.length * 100
    },
    uploadedNum () {
      return this.uploadingFilesProgress.reduce((t, s) => { return t + s }, 0)
    }
  }
}
</script>

<style scoped lang="scss">
.upload-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .upload-progress_bar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    margin-bottom: 30px;

    .progress {
      height: 8px;
      margin: 0;
    }
  }

  .status {
    font-size: 16px;
  }

  .description {
    color: $gray-500;
    font-size: 12px;
  }

  .upload-progress_msg_uploading {
    .status {
      color: $gray-700;
    }
  }

  .upload-progress_msg_uploaded {
    .status {
      color: $primary;
      font-weight: 600;
    }

    .okay-button {
      width: 100px;
      margin-top: 20px;
    }
  }
}

.icon_done {
  margin-left: 5px;
  color: white;
  background-color: $primary;
}
</style>
